import React, { useState, useEffect } from "react";
import i18n from "i18next";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { baseUrl } from "../../helpers/constants";
import LuebArticleDetailsDialog from "../../Controls/LuebArticleDetailsDialog";
import { IBit } from "../../Models/IBit";
import { IPolygonwelle } from "../../Models/IPolygonwelle";
import { INuss } from "../../Models/INuss";
import LuebPagedDataGrid from "../../Controls/LuebPagedDataGrid";
import QuickFinderColumns from "../QuickFinder/QuickFinderColumns";
import Lsp3AngleColumns from "./Lsp3AngleColumns";
import { ILSP3ResponseDto } from "../../Models/ILSP3ResponseDto";
import Lsp3NussColumns from "./Lsp3NussColumns";
import Lsp3PolygonwellenColumns from "./Lsp3PolygonwellenColumns";
import Lsp3BitColumns from "./Lsp3BitColumns";
import {
  Button,
  MessageBar,
  Subtitle1,
  Text,
} from "@fluentui/react-components";
import { ArrowLeftRegular, ArrowRightRegular } from "@fluentui/react-icons";
import { IAddUserBedarfPosition } from "../../Models/IAddUserBedarfPosition";

interface ILsp3SelectionProps {
  configurationParameter: any;
  onSelectionChanged: any;
  preiseSichtbar: boolean;
  onChangePage(item: string): void;
  onOpenDialog(): void;
  onChangePercent(item: number): void;
  isButtonDisabled: boolean;
}

function Lsp3Selection(props: ILsp3SelectionProps) {
  const nussBit =
    props.configurationParameter?.gearedOffsetHeadSpecifications?.nussBit;
  const showNuesse =
    (props.configurationParameter.gearbox.key == "Winkelkopf" &&
      props.configurationParameter.schraubfall != "holdndrive" &&
      props.configurationParameter.fastenerProfile.data.isMaleProfil &&
      props.configurationParameter?.angleHeadSpecifications?.output?.key !=
        "flushsocket") ||
    (props.configurationParameter.gearbox.key != "Winkelkopf" &&
      nussBit &&
      props.configurationParameter.fastenerProfile.data.isMaleProfil);

  const showBits =
    (props.configurationParameter.gearbox.key == "Winkelkopf" &&
      !props.configurationParameter.fastenerProfile.data.isMaleProfil &&
      props.configurationParameter?.angleHeadSpecifications?.output?.key !=
        "flushsocket") ||
    (props.configurationParameter.gearbox.key != "Winkelkopf" &&
      nussBit &&
      !props.configurationParameter.fastenerProfile.data.isMaleProfil &&
      props.configurationParameter?.angleHeadSpecifications?.output?.key !=
        "flushsocket");

  const showPolygonwellen =
    props.configurationParameter.gearbox.key == "Winkelkopf" &&
    props.configurationParameter?.angleHeadSpecifications?.output?.key ==
      "flushsocket"
      ? true
      : false;

  const [artikelDetails, setArtikelDetails] =
    useState<IAddUserBedarfPosition>();
  const [lsp3article, setLsp3Article] = useState<ILSP3ResponseDto[]>([]);
  const [abtriebszahnraeder, setAbtriebszahnraeder] = useState<any[]>([]);
  const [nuesse, setNuesse] = useState<INuss[]>([]);
  const [bits, setBits] = useState<IBit[]>([]);
  const [polygonwellen, setPolygonwellen] = useState<IPolygonwelle[]>([]);

  const [selectedLsp3Article, setSelectedLsp3Article] = useState<
    ILSP3ResponseDto | undefined
  >(props.configurationParameter?.lsp3Selection?.items?.selectedLsp3Article);
  const [selectedAbtriebszahnrad, setSelectedAbtriebszahnrad] = useState<
    any | undefined
  >(
    props.configurationParameter?.lsp3Selection?.items?.selectedAbtriebszahnrad,
  );
  const [selectedNuss, setSelectedNuss] = useState<INuss | undefined>(
    props.configurationParameter?.lsp3Selection?.items?.selectedNuss,
  );
  const [selectedBit, setSelectedBit] = useState<IBit | undefined>(
    props.configurationParameter?.lsp3Selection?.items?.selectedBit,
  );
  const [selectedAntriebsmodul, setSelectedAntriebsmodul] = useState<
    {} | undefined
  >(undefined);

  const [selectedZwischenelement, setSelectedZwischenelement] = useState<
    {} | undefined
  >(undefined);

  useEffect(() => {
    // Wenn sich Paramter ändern muss das Suchergebnis neu geladen werden
    if (
      [
        "Standard_FL_G",
        "Inline_FL_G",
        "Standard_FL_O",
        "Inline_FL_O",
        "Axial_Abtrieb",
      ].includes(props.configurationParameter.gearbox.key)
    ) {
      getLsp3Article();
      getLsp3Touch();
    } else if (props.configurationParameter.gearbox.key == "Winkelkopf") {
      getLsp3Winkelkoepfe();
    }
  }, [
    props.configurationParameter?.gearbox.key,
    props.configurationParameter?.schluesselweite,
    props.configurationParameter?.outputSocketSpecifications?.abtriebsprofil,
  ]);

  useEffect(() => {
    if (
      [
        "Standard_FL_G",
        "Inline_FL_G",
        "Standard_FL_O",
        "Inline_FL_O",
        "Axial_Abtrieb",
      ].includes(props.configurationParameter.gearbox.key) &&
      selectedLsp3Article &&
      selectedLsp3Article.kennzahlAntrieb != undefined &&
      selectedLsp3Article &&
      selectedLsp3Article.artikelId
    ) {
      getLsp3Touch();
      getRueckstellring();

      if (
        ["Inline_FL_G", "Inline_FL_O"].includes(
          props.configurationParameter.gearbox.key,
        )
      ) {
        // Inline Flachabtrieb benötigt ein Antriebsmodul
        getAntriebsmodul();
      } else {
        // Standard Flachabtriebe benötigen ein Antriebsset
        // Wird jetzt in Lsp3Connect ausgewählt!
        //getAntriebsset();
      }
    } else if (
      props.configurationParameter.gearbox.key == "Winkelkopf" &&
      props.configurationParameter?.angleHeadSpecifications?.output?.key ==
        "nut" &&
      selectedLsp3Article &&
      selectedLsp3Article.artikelId
    ) {
      getNuesseForLsp3Angle();
    } else if (
      props.configurationParameter.gearbox.key == "Winkelkopf" &&
      props.configurationParameter?.angleHeadSpecifications?.output?.key ==
        "flushsocket" &&
      selectedLsp3Article &&
      selectedLsp3Article.artikelId
    ) {
      getPolygonwellenForLsp3Angle();
    } else if (
      props.configurationParameter.gearbox.key == "Winkelkopf" &&
      props.configurationParameter?.angleHeadSpecifications?.output?.key ==
        "bitholder" &&
      selectedLsp3Article &&
      selectedLsp3Article.artikelId
    ) {
      getBits();
    } else if (
      props.configurationParameter.gearbox.key == "Winkelkopf" &&
      props.configurationParameter?.angleHeadSpecifications?.output?.key ==
        "holder" &&
      selectedLsp3Article &&
      selectedLsp3Article.artikelId
    ) {
      getLsp3Touch();
    }
  }, [selectedLsp3Article]);

  useEffect(() => {
    const items = {
      selectedNuss: selectedNuss,
      selectedBit: selectedBit,
      selectedLsp3Article: selectedLsp3Article,
      selectedAbtriebszahnrad: selectedAbtriebszahnrad,
      selectedAntriebsmodul: selectedAntriebsmodul,
      selectedZwischenelement: selectedZwischenelement,
    };
    if (
      [
        "Standard_FL_G",
        "Inline_FL_G",
        "Standard_FL_O",
        "Inline_FL_O",
        "Axial_Abtrieb",
      ].includes(props.configurationParameter.gearbox.key)
    ) {
      if (showBits) {
        // Wir brauchen einen Artikel, ein Abtriebszahnrad und einen Bit!
        if (selectedLsp3Article && selectedAbtriebszahnrad && selectedBit) {
          props.onSelectionChanged({ items: items, selectionComplete: true });
        } else {
          props.onSelectionChanged({ items: items, selectionComplete: false });
        }
      } else if (showNuesse) {
        // Wir brauchen einen Artikel, ein Abtriebszahnrad und eine Nuss!
        if (selectedLsp3Article && selectedAbtriebszahnrad && selectedNuss) {
          props.onSelectionChanged({ items: items, selectionComplete: true });
        } else {
          props.onSelectionChanged({ items: items, selectionComplete: false });
        }
      } else {
        // Wir brauchen einen Artikel und ein Abtriebszahnrad!
        if (selectedLsp3Article && selectedAbtriebszahnrad) {
          props.onSelectionChanged({ items: items, selectionComplete: true });
        } else {
          props.onSelectionChanged({ items: items, selectionComplete: false });
        }
      }
    } else if (
      props.configurationParameter.gearbox.key == "Winkelkopf" &&
      props.configurationParameter?.angleHeadSpecifications?.output?.key ==
        "nut"
    ) {
      // Wir brauchen einen Artikel und eine Nuss!
      if (selectedLsp3Article && selectedNuss) {
        props.onSelectionChanged({ items: items, selectionComplete: true });
      } else {
        props.onSelectionChanged({ items: items, selectionComplete: false });
      }
    } else if (
      props.configurationParameter.gearbox.key == "Winkelkopf" &&
      props.configurationParameter?.schraubfall == "holdndrive"
    ) {
      // Wir brauchen einen Artikel und ein Abtriebszahnrad/Gegenhalter!
      if (selectedLsp3Article && selectedAbtriebszahnrad) {
        props.onSelectionChanged({ items: items, selectionComplete: true });
      } else {
        props.onSelectionChanged({ items: items, selectionComplete: false });
      }
    } else if (
      props.configurationParameter.gearbox.key == "Winkelkopf" &&
      props.configurationParameter?.schraubfall == "schraube"
    ) {
      if (selectedLsp3Article && selectedBit) {
        props.onSelectionChanged({ items: items, selectionComplete: true });
      } else {
        props.onSelectionChanged({ items: items, selectionComplete: false });
      }
    } else {
      props.onSelectionChanged({ items: items, selectionComplete: false });
    }
  }, [selectedLsp3Article, selectedAbtriebszahnrad, selectedNuss, selectedBit]);

  useEffect(() => {
    setAbtriebszahnraeder([]);
  }, [selectedLsp3Article]);

  useEffect(() => {
    setNuesse([]);
    setBits([]);
  }, [selectedAbtriebszahnrad]);

  useEffect(() => {
    if (selectedAbtriebszahnrad && nussBit) {
      if (props.configurationParameter.fastenerProfile.data.isMaleProfil) {
        // Nuesse laden
        getNuesse();
      } else {
        // Bits laden
        getBits();
      }
    }
  }, [selectedAbtriebszahnrad]);

  const getLsp3Winkelkoepfe = () => {
    const durchmesser =
      props.configurationParameter.angleHeadSpecifications.durchmesserDMax.mm;
    const hoehe =
      props.configurationParameter.angleHeadSpecifications.heigthHMax.mm;
    const angle =
      props.configurationParameter.angleHeadSpecifications.shaftAngle == "all"
        ? 0
        : Number(
            props.configurationParameter.angleHeadSpecifications.shaftAngle,
          );
    const profil =
      props.configurationParameter?.angleHeadSpecifications?.output?.key ==
      "flushsocket"
        ? "Polygon"
        : props.configurationParameter.angleHeadSpecifications
            .winkelKopfAbtriebsProfil.kurzwort;

    const minAntriebsmoment = props.configurationParameter?.anzugsmoment?.nm;

    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/Configurator/GetLsp3Winkelkoepfe?durchmesser=${durchmesser}&hoehe=${hoehe}&angle=${angle}&minAntriebsmoment=${minAntriebsmoment}&profil=${profil}`,
      )
      .then((result: any) => {
        result.forEach((element: any) => {
          element.key = element.artikelId;
        });

        setLsp3Article(result);
      })
      .catch((error) => {});
  };

  const getNuesseForLsp3Angle = () => {
    const profilAntrieb =
      props.configurationParameter.angleHeadSpecifications
        .winkelKopfAbtriebsProfil.kurzwort;
    const profilAbtrieb =
      props.configurationParameter.angleHeadSpecifications.nutAbtriebsProfil
        .kurzwort;
    const nussDurchmesserMax =
      props.configurationParameter.angleHeadSpecifications.nussDurchmesserDMax
        .mm;
    const nussLaengeMax =
      props.configurationParameter.angleHeadSpecifications.nussLaengeLmax.mm;
    const nussLaengeMin =
      props.configurationParameter.angleHeadSpecifications.nussLaengeLmin.mm;
    const artikelIdWinkelkopf = selectedLsp3Article?.artikelId;

    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/Configurator/GetNuesseForLsp3Angle?artikelIdWinkelkopf=${artikelIdWinkelkopf}&profilAntrieb=${profilAntrieb}&profilAbtrieb=${profilAbtrieb}&nussDurchmesserMax=${nussDurchmesserMax}&nussLaengeMax=${nussLaengeMax}&nussLaengeMin=${nussLaengeMin}`,
      )
      .then((result: any) => {
        result.forEach((element: any) => {
          element.key = element.artikelId;
        });
        setNuesse(result);
      })
      .finally(() => {});
  };

  const getPolygonwellenForLsp3Angle = () => {
    const artikelIdWinkelkopf = selectedLsp3Article?.artikelId;
    const profilAbtrieb = props.configurationParameter.fastenerProfile.kurzwort;

    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/Configurator/GetPolygonwellen?artikelIdWinkelkopf=${artikelIdWinkelkopf}&profilAbtrieb=${profilAbtrieb}`,
      )
      .then((result: any) => {
        result.forEach((element: any) => {
          element.key = element.artikelId;
        });
        setPolygonwellen(result);
      })
      .finally(() => {});
  };

  const getBits = () => {
    //GetBits

    const profilGuidAntrieb =
      props.configurationParameter.gearbox.key == "Winkelkopf"
        ? ""
        : selectedAbtriebszahnrad?.schraubprofilGuid;
    const profilAbtrieb = props.configurationParameter.fastenerProfile.kurzwort;

    const bitLaengeMax =
      props.configurationParameter.gearbox.key == "Winkelkopf"
        ? props.configurationParameter.angleHeadSpecifications.nussLaengeLmax.mm
        : props.configurationParameter.gearedOffsetHeadSpecifications.laengeLmax
            .mm;
    const bitLaengeMin =
      props.configurationParameter.gearbox.key == "Winkelkopf"
        ? props.configurationParameter.angleHeadSpecifications.nussLaengeLmin.mm
        : props.configurationParameter.gearedOffsetHeadSpecifications.laengeLmin
            .mm;

    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/Configurator/GetBits?profilGuidAntrieb=${profilGuidAntrieb}&profilAbtrieb=${profilAbtrieb}&bitLaengeMax=${bitLaengeMax}&bitLaengeMin=${bitLaengeMin}`,
      )
      .then((result: any) => {
        result.forEach((element: any) => {
          element.key = element.artikelId;
        });
        setBits(result);
      })
      .finally(() => {});
  };

  const getNuesse = () => {
    const profilAntrieb =
      props.configurationParameter.outputSocketSpecifications.abtriebsprofil
        .kurzwort;
    const profilAbtrieb = props.configurationParameter.fastenerProfile.kurzwort;
    const nussDurchmesserMax =
      props.configurationParameter.gearedOffsetHeadSpecifications
        .durchmesserDMax.mm;
    const nussLaengeMax =
      props.configurationParameter.gearedOffsetHeadSpecifications.laengeLmax.mm;
    const nussLaengeMin =
      props.configurationParameter.gearedOffsetHeadSpecifications.laengeLmin.mm;

    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/Configurator/GetNuesse?profilAntrieb=${profilAntrieb}&profilAbtrieb=${profilAbtrieb}&nussDurchmesserMax=${nussDurchmesserMax}&nussLaengeMax=${nussLaengeMax}&nussLaengeMin=${nussLaengeMin}`,
      )
      .then((result: any) => {
        result.forEach((element: any) => {
          element.key = element.artikelId;
        });
        setNuesse(result);
      })
      .finally(() => {});
  };

  let type = "";
  switch (props.configurationParameter.gearbox.key) {
    case "Standard_FL_G":
      type = "lsp3_c_outline";
      break;
    case "Inline_FL_G":
      type = "lsp3_c_inline";
      break;
    case "Standard_FL_O":
      type = "lsp3_o_outline";
      break;
    case "Inline_FL_O":
      type = "lsp3_o_inline";
      break;
    case "Axial_Abtrieb":
      type = "lsp3_straight";
      break;
    case "Winkelkopf":
      type = "winkelkopf";
      break;
  }

  const getLsp3Article = () => {
    let queryValues = {};

    if (
      ["Standard_FL_G", "Inline_FL_G", "Standard_FL_O", "Inline_FL_O"].includes(
        props.configurationParameter.gearbox.key,
      )
    ) {
      queryValues = {
        type: type,
        MaxRadius: parseFloat(
          props.configurationParameter.gearedOffsetHeadSpecifications.maxRadius
            .mm,
        ),
        MaxKlingenstaerke: parseFloat(
          props.configurationParameter.gearedOffsetHeadSpecifications
            .maxKlingenstaerke.mm,
        ),
        MaxBreite: parseFloat(
          props.configurationParameter.gearedOffsetHeadSpecifications.maxBreite
            .mm,
        ),
        AchsabstandMin: parseFloat(
          props.configurationParameter.gearedOffsetHeadSpecifications
            .achsabstandMin.mm,
        ),
        AchsabstandMax: parseFloat(
          props.configurationParameter.gearedOffsetHeadSpecifications
            .achsabstandMax.mm,
        ),
        Auskraglaenge: parseFloat(
          props.configurationParameter.gearedOffsetHeadSpecifications
            .auskraglaenge.mm,
        ),
        AbtriebsprofilGuid:
          props.configurationParameter.outputSocketSpecifications.abtriebsprofil
            .key,
        MinMoment: parseFloat(props.configurationParameter.anzugsmoment.nm),
        NennweiteAbtriebsprofil: props.configurationParameter.schluesselweite.mm
          ? parseFloat(props.configurationParameter.schluesselweite.mm)
          : 0,
      };
    } else {
      queryValues = {
        type: type,
      };
    }

    if (queryValues != undefined) {
      fetchWrapper
        .postWithAuth(
          `${baseUrl}/api/Configurator/GetLsp3AccessModels`,
          queryValues,
        )
        .then((result: any) => {
          result.forEach((element: any) => {
            element.key = element.artikelId;
            element.hasSachwerte = true;
          });
          setLsp3Article(result);
        })
        .catch((error) => {});
    }
  };

  useEffect(() => {
    setSelectedAbtriebszahnrad(undefined);
    setSelectedBit(undefined);
    setSelectedNuss(undefined);
    if (nuesse.length > 0) {
      setNuesse([]);
    }

    if (bits.length > 0) {
      setBits([]);
    }

    if (polygonwellen.length > 0) {
      setPolygonwellen([]);
    }

    if (abtriebszahnraeder.length > 0) {
      setAbtriebszahnraeder([]);
    }
  }, [lsp3article]);

  useEffect(() => {
    setSelectedBit(undefined);
    setSelectedNuss(undefined);
  }, [abtriebszahnraeder]);

  const getLsp3Touch = () => {
    if (selectedLsp3Article && selectedLsp3Article.artikelId) {
      // Abtriebszahnraeder nur laden wenn ein LSP3 Artikel ausgewählt wurde

      let queryValues = {};

      if (
        [
          "Standard_FL_G",
          "Inline_FL_G",
          "Standard_FL_O",
          "Inline_FL_O",
        ].includes(props.configurationParameter.gearbox.key)
      ) {
        queryValues = {
          Type: type,
          SelectedArtikelId: selectedLsp3Article
            ? selectedLsp3Article.artikelId
            : "",
          MaxLaenge:
            props.configurationParameter?.outputSocketSpecifications?.laengeLmax
              .mm,
          MinAussenlaenge:
            props.configurationParameter?.outputSocketSpecifications
              ?.aussenlaengeALMin.mm,
          MaxAussenlaenge:
            props.configurationParameter?.outputSocketSpecifications
              ?.aussenlaengeALMax.mm,
          MinOeffnungsweite:
            props.configurationParameter?.outputSocketSpecifications
              ?.oeffnungsweiteCMin.mm,
          AbtriebsprofilGuid:
            props.configurationParameter?.outputSocketSpecifications
              ?.abtriebsprofil.key,
          GegenhalterprofilGuid:
            props.configurationParameter?.retainingProfile?.key,
          MinProfiltiefe:
            props.configurationParameter.outputSocketSpecifications
              ?.profiltiefePMin.mm,
          NennweiteAbtriebsprofil: props.configurationParameter.schluesselweite
            .mm
            ? parseFloat(props.configurationParameter.schluesselweite.mm)
            : 0,
          MaxAbtriebsmoment: props.configurationParameter.anzugsmoment.nm,
        };
      } else if (props.configurationParameter.gearbox.key == "Axial_Abtrieb") {
        queryValues = {
          Type: type,
          SelectedArtikelId: selectedLsp3Article
            ? selectedLsp3Article.artikelId
            : "",
          AbtriebsprofilGuid:
            props.configurationParameter?.fastenerProfile?.key,
          GegenhalterprofilGuid:
            props.configurationParameter?.retainingProfile?.key,
          NennweiteAbtriebsprofil: props.configurationParameter.schluesselweite
            .mm
            ? parseFloat(props.configurationParameter.schluesselweite.mm)
            : 0,
          MaxAbtriebsmoment: props.configurationParameter.anzugsmoment.nm,
        };
      } else {
        queryValues = {
          type: type,
          SelectedArtikelId: selectedLsp3Article
            ? selectedLsp3Article.artikelId
            : "",
          GegenhalterprofilGuid:
            props.configurationParameter?.retainingProfile?.key,
          AbtriebsprofilGuid:
            props.configurationParameter?.fastenerProfile?.key,
        };
      }

      if (queryValues != undefined) {
        if (props.configurationParameter.schraubfall == "holdndrive") {
          fetchWrapper
            .postWithAuth(
              `${baseUrl}/api/Configurator/GetAbtriebGegenhalter`,
              queryValues,
            )
            .then((result: any) => {
              result.forEach((element: any) => {
                element.key = element.artikelId;
              });
              setAbtriebszahnraeder(result);
            });
        } else {
          fetchWrapper
            .postWithAuth(
              `${baseUrl}/api/Configurator/GetAbtriebszahnraeder`,
              queryValues,
            )
            .then((result: any) => {
              result.forEach((element: any) => {
                element.key = element.artikelId;
              });
              setAbtriebszahnraeder(result);
            });
        }
      }
    }
  };

  const getAntriebsmodul = () => {
    // TODO: Kennzahl vom Artikel verwenden, aktuell fest damit immer ein Antriebsset ausgewählt wird! ${selectedLsp3Article?.kennzahlAntrieb}

    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/Configurator/GetAntriebsmodule?kennzahlAntrieb=${selectedLsp3Article?.kennzahlAntrieb}`,
      )
      .then((result: any) => {
        // TODO: Hier wird das erste Antriebsmodul ausgewählt, da ich nicht weiß wie viele zurückgegeben werden könnten. Kann man das besser lösen?
        if (result.length > 0) {
          setSelectedAntriebsmodul(result[0]);
        }
      });
  };

  const getRueckstellring = () => {
    if (
      props.configurationParameter.schraubfall == "rohrleitung" &&
      props.configurationParameter.gearbox.key != "Inline_FL_O"
    ) {
      let typ = "";
      if (props.configurationParameter.rueckstellung == "mechanisch") {
        typ = "Rückstellring_mechanisch";
      } else if (props.configurationParameter.rueckstellung == "sensorisch") {
        typ = "Rückstellring_sensorisch";
      }

      if (typ != "" && selectedLsp3Article?.baukasten != "") {
        fetchWrapper
          .getWithAuth(
            `${baseUrl}/api/Configurator/GetZwischenelement?typ=${typ}&baukasten=${selectedLsp3Article?.baukasten}`,
          )
          .then((result: any) => {
            // TODO: Rückstellring einbinden
            setSelectedZwischenelement(result);
          });
      }
    }
  };

  // ----- Columns für normale Falchabtriebe ------
  const columns = QuickFinderColumns({
    openInNewTab: true,
    type: type,
    showButtons: false,
    preiseSichtbar: props.preiseSichtbar,
    selectedAbtriebsprofilGuid: props.configurationParameter.gearbox.key,
    onAddBedarf: (item: IAddUserBedarfPosition) => {
      setArtikelDetails(item);
    },
    onShowPdf: (item: string | undefined) => {},
    onDownloadKvm: (item: string | undefined) => {},
    onGetAbtriebsZahnräder: (item: string | undefined) => {},
  });

  // ----- Columns für angewinkelte Falchabtriebe ------
  const angleColumns = Lsp3AngleColumns(props.preiseSichtbar);

  // ----- Columns für Abtriebszahnräder -------
  const columnsAbtriebsZahnräder = QuickFinderColumns({
    openInNewTab: true,
    type:
      props.configurationParameter.schraubfall == "holdndrive"
        ? "abtriebgegenhalter"
        : "abtriebszahnrad",
    showButtons: false,
    preiseSichtbar: props.preiseSichtbar,
    selectedAbtriebsprofilGuid: props.configurationParameter
      ?.outputSocketSpecifications?.abtriebsprofil?.key
      ? props.configurationParameter?.outputSocketSpecifications?.abtriebsprofil
          ?.key
      : props.configurationParameter.retainingProfile.key,
    onAddBedarf: (item: IAddUserBedarfPosition) => {
      setArtikelDetails(item);
    },
    onShowPdf: function (item: string | undefined): void {
      throw new Error("Function not implemented.");
    },
    onDownloadKvm: function (item: string | undefined): void {
      throw new Error("Function not implemented.");
    },
    onGetAbtriebsZahnräder: function (item: string | undefined): void {
      throw new Error("Function not implemented.");
    },
  });

  // ----- Columns für Nüsse ------
  const nussColumns = Lsp3NussColumns(props.preiseSichtbar);

  // ----- Columns für Bits ------
  const bitColumns = Lsp3BitColumns(props.preiseSichtbar);

  // ----- Columns für Polygonwellen ------
  const polygonwellenColumns = Lsp3PolygonwellenColumns(props.preiseSichtbar);

  return (
    <div style={{ marginBottom: "10px" }}>
      <LuebArticleDetailsDialog
        onClose={() => {
          setArtikelDetails({
            menge: 0,
            artikel: undefined,
            kundenReferenz: undefined,
            reference: undefined,
            produkt: undefined,
            benennung: undefined,
          });
        }}
        isDialogOpen={artikelDetails?.artikel != undefined ? true : false}
        artikelId={artikelDetails?.artikel ?? ""}
        benennungDE={artikelDetails?.benennung ?? ""}
        benennungEN={artikelDetails?.benennung ?? ""}
      />
      {/* L.SP3 Artikel */}
      {/* <Divider
        appearance="brand"
        style={{ marginTop: "10px", marginBottom: "15px" }}
      >
        {i18n.t<string>(
          props.configurationParameter.gearbox.key == "Winkelkopf"
            ? "auswahlWinkelkopf"
            : "auswahlLsp3",
        )}
      </Divider> */}
      <Subtitle1 style={{ marginLeft: "10px" }}>
        {i18n.t<string>(
          props.configurationParameter.gearbox.key == "Winkelkopf"
            ? "auswahlWinkelkopf"
            : "auswahlLsp3",
        )}
      </Subtitle1>
      <div className="lueb-ContentBlock">
        <LuebPagedDataGrid
          selectionMode="single"
          onPageChanged={() => {
            setSelectedLsp3Article(undefined);
          }}
          selectedItems={
            selectedLsp3Article
              ? new Set([lsp3article.indexOf(selectedLsp3Article)])
              : new Set([])
          }
          onSelectionChange={(ev, data) => {
            const selItem = data.selectedItems;
            lsp3article.forEach((obj, index) => {
              if (selItem.has(index)) {
                setSelectedLsp3Article(obj);
              }
            });
          }}
          columns={
            [
              "Standard_FL_G",
              "Inline_FL_G",
              "Standard_FL_O",
              "Inline_FL_O",
              "Axial_Abtrieb",
            ].includes(props.configurationParameter.gearbox.key)
              ? columns
              : props.configurationParameter.gearbox.key == "Winkelkopf"
              ? angleColumns
              : []
          }
          items={lsp3article}
          resizableColumns={true}
          columnSizingOptions={{
            checkedId: { minWidth: 50, defaultWidth: 50 },
            artikelId: { minWidth: 100, defaultWidth: 100 },
            benennungMl: { minWidth: 250, defaultWidth: 250 },
            nennweiteAbtrieb: { minWidth: 50, defaultWidth: 50 },
            nennweite: { minWidth: 50, defaultWidth: 50 },
            nennweiteInch: { minWidth: 50, defaultWidth: 50 },
            getriebeMaxAbtriebsmoment: { minWidth: 50, defaultWidth: 50 },
            auskraglaenge: { minWidth: 50, defaultWidth: 50 },
            maxAbtriebsmoment: { minWidth: 50, defaultWidth: 50 },
            profilAbtrieb: { minWidth: 50, defaultWidth: 50 },
            durchmesserAbtriebId: { minWidth: 50, defaultWidth: 50 },
            hoeheAbtriebId: { minWidth: 50, defaultWidth: 50 },
            achswinkelAbtriebId: { minWidth: 50, defaultWidth: 50 },
            maxHexSize: { minWidth: 50, defaultWidth: 50 },
            anzahlStufen: { minWidth: 30, defaultWidth: 30 },
            radius: { minWidth: 50, defaultWidth: 50 },
            achsabstand: { minWidth: 50, defaultWidth: 50 },
            klingenstaerke: { minWidth: 50, defaultWidth: 50 },
            breite: { minWidth: 50, defaultWidth: 50 },
            kopfmass: { minWidth: 50, defaultWidth: 50 },
            oeffnungsweite: { minWidth: 50, defaultWidth: 50 },
          }}
        />
        {lsp3article.length == 0 && (
          <MessageBar style={{ marginTop: 10 }} intent="error">
            {i18n.t<string>("noLsp3ArticleFound")}
          </MessageBar>
        )}
        {props.preiseSichtbar && (
          <div style={{ marginTop: 10 }}>
            <Text style={{ color: "#ff6600", fontWeight: 700 }}>*</Text>
            {i18n.t<string>("priceNote")}
          </div>
        )}
      </div>
      {([
        "Standard_FL_G",
        "Inline_FL_G",
        "Standard_FL_O",
        "Inline_FL_O",
        "Axial_Abtrieb",
      ].includes(props.configurationParameter.gearbox.key) ||
        (props.configurationParameter.gearbox.key == "Winkelkopf" &&
          props.configurationParameter.schraubfall == "holdndrive")) &&
        selectedLsp3Article != undefined && (
          <>
            <Subtitle1 style={{ marginLeft: "10px" }}>
              {props.configurationParameter.schraubfall == "holdndrive"
                ? i18n.t<string>("auswahlAbtriebGegenhalter")
                : i18n.t<string>("auswahlAbtriebszahnrad")}
            </Subtitle1>
            <div className="lueb-ContentBlock">
              <LuebPagedDataGrid
                onPageChanged={() => {
                  setSelectedAbtriebszahnrad(undefined);
                }}
                selectionMode="single"
                selectedItems={
                  selectedAbtriebszahnrad
                    ? new Set([
                        abtriebszahnraeder.indexOf(selectedAbtriebszahnrad),
                      ])
                    : new Set([])
                }
                onSelectionChange={(ev, data) => {
                  const selItem = data.selectedItems;
                  abtriebszahnraeder.forEach((obj, index) => {
                    if (selItem.has(index)) {
                      setSelectedAbtriebszahnrad(obj);
                    }
                  });
                }}
                columns={columnsAbtriebsZahnräder}
                items={abtriebszahnraeder}
                resizableColumns={true}
                columnSizingOptions={{
                  artikelId: { minWidth: 100, defaultWidth: 100 },
                  benennungMl: { minWidth: 150, defaultWidth: 150 },
                  schraubprofil: { minWidth: 150, defaultWidth: 150 },
                  checkedId: { minWidth: 50, defaultWidth: 50 },
                  nennweite: { minWidth: 50, defaultWidth: 50 },
                  oeffnungsweite: { minWidth: 50, defaultWidth: 50 },
                  nennweiteInch: { minWidth: 50, defaultWidth: 50 },
                  laenge: { minWidth: 50, defaultWidth: 50 },
                  aussenlaenge: { minWidth: 50, defaultWidth: 50 },
                  profiltiefe: { minWidth: 50, defaultWidth: 50 },
                  maxAbtriebsmoment: { minWidth: 50, defaultWidth: 50 },
                }}
              />
              {selectedLsp3Article?.artikelId == "" && (
                <MessageBar style={{ marginTop: 10 }} intent="warning">
                  {i18n.t<string>("pleaseSelectLsp3ArticleOutputGear")}
                </MessageBar>
              )}
              {abtriebszahnraeder.length == 0 &&
                selectedLsp3Article?.artikelId != "" && (
                  <MessageBar style={{ marginTop: 10 }} intent="error">
                    {i18n.t<string>("noLsp3TouchFound")}
                  </MessageBar>
                )}
              {props.preiseSichtbar && (
                <div style={{ marginTop: 10 }}>
                  <Text style={{ color: "#ff6600", fontWeight: 700 }}>*</Text>
                  {i18n.t<string>("priceNote")}
                </div>
              )}
              {!showNuesse && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                >
                  <Button
                    icon={<ArrowLeftRegular />}
                    onClick={() => {
                      if (
                        [
                          "Standard_FL_G",
                          "Inline_FL_G",
                          "Standard_FL_O",
                          "Inline_FL_O",
                        ].includes(props.configurationParameter.gearbox.key)
                      ) {
                        props.onChangePage("lsp3touch");
                        props.onChangePercent(0.4);
                      } else if (
                        props.configurationParameter.gearbox.key ==
                        "Axial_Abtrieb"
                      ) {
                        props.onChangePage("model");
                        props.onChangePercent(0.2);
                      } else if (
                        props.configurationParameter.gearbox.key == "Winkelkopf"
                      ) {
                        props.onChangePage("headSpecifications");
                        props.onChangePercent(0.3);
                      }
                    }}
                  >
                    {i18n.t<string>("back")}
                  </Button>
                  <Button
                    icon={<ArrowRightRegular />}
                    appearance={"primary"}
                    disabled={props.isButtonDisabled}
                    onClick={() => {
                      // Meldung über ausgewähltes Antriebsset einblenden, in diesem wird dann das Pivot weitergeschaltet
                      if (
                        props.configurationParameter.gearbox.key != "Winkelkopf"
                      ) {
                        props.onOpenDialog();
                      } else {
                        if (
                          ["Standard_FL_G", "Standard_FL_O"].includes(
                            props.configurationParameter.gearbox.key,
                          )
                        ) {
                          // Wenn LSP3 Standard, Connect Pivot anzeigen
                          props.onChangePage("lsp3Connect");
                        } else {
                          // Sonst direkt zur Toolauswahl
                          props.onChangePage("toolSelection");
                        }
                      }
                      props.onChangePercent(0.6);
                    }}
                  >
                    {i18n.t<string>("next")}
                  </Button>
                </div>
              )}
            </div>
          </>
        )}

      {showNuesse && (
        <>
          <Subtitle1 style={{ marginLeft: "10px" }}>
            {i18n.t<string>("auswahlNuss")}
          </Subtitle1>
          <div className="lueb-ContentBlock">
            <LuebPagedDataGrid
              onPageChanged={() => {
                setSelectedNuss(undefined);
              }}
              selectionMode="single"
              selectedItems={
                selectedNuss
                  ? new Set([nuesse.indexOf(selectedNuss)])
                  : new Set([])
              }
              onSelectionChange={(ev, data) => {
                const selItem = data.selectedItems;
                nuesse.forEach((obj, index) => {
                  if (selItem.has(index)) {
                    setSelectedNuss(obj);
                  }
                });
              }}
              columns={nussColumns.columns}
              items={nuesse}
              resizableColumns={true}
              columnSizingOptions={{
                checkedId: { minWidth: 50, defaultWidth: 50 },
                schraubprofil: { minWidth: 150, defaultWidth: 150 },
                artikelId: { minWidth: 100, defaultWidth: 100 },
                benennungId: { minWidth: 270, defaultWidth: 270 },
                nennwiteId: { minWidth: 50, defaultWidth: 50 },
                nennwiteInchId: { minWidth: 50, defaultWidth: 50 },
                profilAbtriebId: { minWidth: 50, defaultWidth: 50 },
                laengeId: { minWidth: 50, defaultWidth: 50 },
                durchmesserId: { minWidth: 50, defaultWidth: 50 },
                preisId: { minWidth: 50, defaultWidth: 50 },
              }}
            />
            {nuesse.length == 0 &&
              selectedAbtriebszahnrad != undefined &&
              !props.configurationParameter?.gearedOffsetHeadSpecifications
                ?.nussBit && (
                <MessageBar style={{ marginTop: 10 }} intent="error">
                  {i18n.t<string>("noNutFound")}
                </MessageBar>
              )}

            {selectedLsp3Article?.artikelId != "" &&
              selectedAbtriebszahnrad == undefined &&
              [
                "Standard_FL_G",
                "Inline_FL_G",
                "Standard_FL_O",
                "Inline_FL_O",
                "Axial_Abtrieb",
              ].includes(props.configurationParameter.gearbox.key) && (
                <MessageBar style={{ marginTop: 10 }} intent="warning">
                  {i18n.t<string>("pleaseSelectLsp3ArticleNut")}
                </MessageBar>
              )}
            {props.preiseSichtbar && (
              <div style={{ marginTop: 10 }}>
                <Text style={{ color: "#ff6600", fontWeight: 700 }}>*</Text>
                {i18n.t<string>("priceNote")}
              </div>
            )}
            {!showBits && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <Button
                  icon={<ArrowLeftRegular />}
                  onClick={() => {
                    if (
                      [
                        "Standard_FL_G",
                        "Inline_FL_G",
                        "Standard_FL_O",
                        "Inline_FL_O",
                      ].includes(props.configurationParameter.gearbox.key)
                    ) {
                      props.onChangePage("lsp3touch");
                      props.onChangePercent(0.4);
                    } else if (
                      props.configurationParameter.gearbox.key ==
                      "Axial_Abtrieb"
                    ) {
                      props.onChangePage("model");
                      props.onChangePercent(0.2);
                    } else if (
                      props.configurationParameter.gearbox.key == "Winkelkopf"
                    ) {
                      props.onChangePage("headSpecifications");
                      props.onChangePercent(0.3);
                    }
                  }}
                >
                  {i18n.t<string>("back")}
                </Button>
                <Button
                  icon={<ArrowRightRegular />}
                  appearance={"primary"}
                  disabled={props.isButtonDisabled}
                  onClick={() => {
                    // Meldung über ausgewähltes Antriebsset einblenden, in diesem wird dann das Pivot weitergeschaltet
                    if (
                      props.configurationParameter.gearbox.key != "Winkelkopf"
                    ) {
                      props.onOpenDialog();
                    } else {
                      if (
                        ["Standard_FL_G", "Standard_FL_O"].includes(
                          props.configurationParameter.gearbox.key,
                        )
                      ) {
                        // Wenn LSP3 Standard, Connect Pivot anzeigen
                        props.onChangePage("lsp3Connect");
                      } else {
                        // Sonst direkt zur Toolauswahl
                        props.onChangePage("toolSelection");
                      }
                    }
                    props.onChangePercent(0.6);
                  }}
                >
                  {i18n.t<string>("next")}
                </Button>
              </div>
            )}
          </div>
        </>
      )}
      {showBits && (
        <>
          <Subtitle1 style={{ marginLeft: "10px" }}>
            {i18n.t<string>("auswahlBit")}
          </Subtitle1>
          <div className="lueb-ContentBlock">
            <LuebPagedDataGrid
              onPageChanged={() => {
                setSelectedBit(undefined);
              }}
              selectionMode="single"
              selectedItems={
                selectedBit ? new Set([bits.indexOf(selectedBit)]) : new Set([])
              }
              onSelectionChange={(ev, data) => {
                const selItem = data.selectedItems;
                bits.forEach((obj, index) => {
                  if (selItem.has(index)) {
                    setSelectedBit(obj);
                  }
                });
              }}
              columns={bitColumns.columns}
              items={bits}
              resizableColumns={true}
              columnSizingOptions={{
                checkedId: { minWidth: 50, defaultWidth: 50 },
                artikelId: { minWidth: 100, defaultWidth: 100 },
                schraubprofil: { minWidth: 150, defaultWidth: 150 },
                benennungMl: { minWidth: 250, defaultWidth: 250 },
                nennwiteId: { minWidth: 50, defaultWidth: 50 },
                nennwiteInchId: { minWidth: 50, defaultWidth: 50 },
                profilAbtriebId: { minWidth: 50, defaultWidth: 50 },
                laengeId: { minWidth: 50, defaultWidth: 50 },
              }}
            />
            {bits.length == 0 &&
              selectedAbtriebszahnrad != undefined &&
              !props.configurationParameter?.gearedOffsetHeadSpecifications
                ?.nussBit && (
                <MessageBar style={{ marginTop: 10 }} intent="error">
                  {i18n.t<string>("noBitFound")}
                </MessageBar>
              )}

            {selectedLsp3Article?.artikelId != "" &&
              selectedAbtriebszahnrad == undefined &&
              props.configurationParameter.gearbox.key != "Winkelkopf" && (
                <MessageBar style={{ marginTop: 10 }} intent="warning">
                  {i18n.t<string>("pleaseSelectLsp3ArticleBit")}
                </MessageBar>
              )}
            {props.preiseSichtbar && (
              <div style={{ marginTop: 10 }}>
                <Text style={{ color: "#ff6600", fontWeight: 700 }}>*</Text>
                {i18n.t<string>("priceNote")}
              </div>
            )}
            {!showPolygonwellen && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <Button
                  icon={<ArrowLeftRegular />}
                  onClick={() => {
                    if (
                      [
                        "Standard_FL_G",
                        "Inline_FL_G",
                        "Standard_FL_O",
                        "Inline_FL_O",
                      ].includes(props.configurationParameter.gearbox.key)
                    ) {
                      props.onChangePage("lsp3touch");
                      props.onChangePercent(0.4);
                    } else if (
                      props.configurationParameter.gearbox.key ==
                      "Axial_Abtrieb"
                    ) {
                      props.onChangePage("model");
                      props.onChangePercent(0.2);
                    } else if (
                      props.configurationParameter.gearbox.key == "Winkelkopf"
                    ) {
                      props.onChangePage("headSpecifications");
                      props.onChangePercent(0.3);
                    }
                  }}
                >
                  {i18n.t<string>("back")}
                </Button>
                <Button
                  icon={<ArrowRightRegular />}
                  appearance={"primary"}
                  disabled={props.isButtonDisabled}
                  onClick={() => {
                    // Meldung über ausgewähltes Antriebsset einblenden, in diesem wird dann das Pivot weitergeschaltet
                    if (
                      props.configurationParameter.gearbox.key != "Winkelkopf"
                    ) {
                      props.onOpenDialog();
                    } else {
                      if (
                        ["Standard_FL_G", "Standard_FL_O"].includes(
                          props.configurationParameter.gearbox.key,
                        )
                      ) {
                        // Wenn LSP3 Standard, Connect Pivot anzeigen
                        props.onChangePage("lsp3Connect");
                      } else {
                        // Sonst direkt zur Toolauswahl
                        props.onChangePage("toolSelection");
                      }
                    }
                    props.onChangePercent(0.6);
                  }}
                >
                  {i18n.t<string>("next")}
                </Button>
              </div>
            )}
          </div>
        </>
      )}
      {showPolygonwellen && (
        <>
          {/* <Divider
            appearance="brand"
            style={{ marginTop: "10px", marginBottom: "15px" }}
          >
            {i18n.t<string>("auswahlFlushSocket")}
          </Divider> */}
          <Subtitle1 style={{ marginLeft: "10px" }}>
            {i18n.t<string>("auswahlFlushSocket")}
          </Subtitle1>
          <div className="lueb-ContentBlock">
            <LuebPagedDataGrid
              onPageChanged={() => {
                setSelectedBit(undefined);
              }}
              selectionMode="single"
              selectedItems={
                selectedBit
                  ? new Set([
                      polygonwellen.findIndex(
                        (x) => x.artikelId == selectedBit?.artikelId,
                      ),
                    ])
                  : new Set([])
              }
              onSelectionChange={(ev, data) => {
                const selItem = data.selectedItems;
                polygonwellen.forEach((obj, index) => {
                  if (selItem.has(index)) {
                    setSelectedBit(obj as unknown as IBit);
                  }
                });
              }}
              columns={polygonwellenColumns.columns}
              items={polygonwellen}
              resizableColumns={true}
              columnSizingOptions={{
                checkedId: { minWidth: 50, defaultWidth: 50 },
                artikelId: { minWidth: 100, defaultWidth: 100 },
                benennungM1: { minWidth: 270, defaultWidth: 270 },
                nennwiteId: { minWidth: 50, defaultWidth: 50 },
                nennwiteInchId: { minWidth: 50, defaultWidth: 50 },
                profilAbtriebId: { minWidth: 50, defaultWidth: 50 },
                laengeId: { minWidth: 50, defaultWidth: 50 },
                durchmesserId: { minWidth: 50, defaultWidth: 50 },
                preisId: { minWidth: 50, defaultWidth: 50 },
              }}
            />
            {selectedLsp3Article?.artikelId != "" &&
              polygonwellen.length == 0 && (
                <MessageBar style={{ marginTop: 10 }} intent="warning">
                  {i18n.t<string>("pleaseSelectLsp3ArticlePolygonwelle")}
                </MessageBar>
              )}
            {props.preiseSichtbar && (
              <div style={{ marginTop: 10 }}>
                <Text style={{ color: "#ff6600", fontWeight: 700 }}>*</Text>
                {i18n.t<string>("priceNote")}
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
              }}
            >
              <Button
                icon={<ArrowLeftRegular />}
                onClick={() => {
                  if (
                    [
                      "Standard_FL_G",
                      "Inline_FL_G",
                      "Standard_FL_O",
                      "Inline_FL_O",
                    ].includes(props.configurationParameter.gearbox.key)
                  ) {
                    props.onChangePage("lsp3touch");
                    props.onChangePercent(0.4);
                  } else if (
                    props.configurationParameter.gearbox.key == "Axial_Abtrieb"
                  ) {
                    props.onChangePage("model");
                    props.onChangePercent(0.2);
                  } else if (
                    props.configurationParameter.gearbox.key == "Winkelkopf"
                  ) {
                    props.onChangePage("headSpecifications");
                    props.onChangePercent(0.3);
                  }
                }}
              >
                {i18n.t<string>("back")}
              </Button>
              <Button
                icon={<ArrowRightRegular />}
                appearance={"primary"}
                disabled={props.isButtonDisabled}
                onClick={() => {
                  // Meldung über ausgewähltes Antriebsset einblenden, in diesem wird dann das Pivot weitergeschaltet
                  if (
                    props.configurationParameter.gearbox.key != "Winkelkopf"
                  ) {
                    props.onOpenDialog();
                  } else {
                    if (
                      ["Standard_FL_G", "Standard_FL_O"].includes(
                        props.configurationParameter.gearbox.key,
                      )
                    ) {
                      // Wenn LSP3 Standard, Connect Pivot anzeigen
                      props.onChangePage("lsp3Connect");
                    } else {
                      // Sonst direkt zur Toolauswahl
                      props.onChangePage("toolSelection");
                    }
                  }
                  props.onChangePercent(0.6);
                }}
              >
                {i18n.t<string>("next")}
              </Button>
            </div>
          </div>
        </>
      )}
      {/*wenn eine Artikel Id mit P anfängt, dann MessageBar ausgeben*/}
      {selectedLsp3Article?.artikelId != "" && (
        <>
          {(abtriebszahnraeder.length == 1 &&
            abtriebszahnraeder[0].artikelId.startsWith("P")) ||
            (nuesse.length == 1 && nuesse[0].artikelId.startsWith("P")) ||
            (polygonwellen.length == 1 &&
              polygonwellen[0].artikelId.startsWith("P")) ||
            (bits.length == 1 && bits[0].artikelId.startsWith("P") && (
              <MessageBar style={{ marginTop: 10 }} intent="warning">
                {i18n.t<string>("artikelNachKundenanforderung")}
              </MessageBar>
            ))}
        </>
      )}
    </div>
  );
}

export default Lsp3Selection;
